module.exports = __webpack_public_path__ + "img/sol_isol_pain2.e2957c87.png";